import { useContext } from "react";
import { GlobalConfigContext } from "../../../context/GlobalConfigContext";
import { useSegmentProcessor } from "../../../hooks/useSegmentProcessor";
import { getDateWithFormat } from "../../../utils/commons";
import { FeatureToggle, useFeatureToggle } from "../../../utils/featureToggle";
import ButtonGroupDynamic from "../../common/ButtonGroupDynamic";
import { getCampaignActionButtons } from "../CampaignListing/CampaignActionButtons";
import "../campaignListView.scss";

const columnStyles = {
  status: { width: "9%" },
  title: { width: "17%" },
  reward: { width: "16%" },
  population: { width: "10%" },
  uniqueSegmentedUsersCount: { width: "10%" },
  segment: { width: "6%" },
  actions: { width: "14%" },
};

const BonusListView = ({
  campaignData,
  handleEditCampaign,
  handleCopyClick,
  handleSummaryClick,
  handleDeleteClick,
  hasAccess,
}) => {
  const isBonusFlowEnabled = useFeatureToggle(FeatureToggle.isBonusFlowEnabled);
  const segmentData = useSegmentProcessor(campaignData);
  const { programTimezone } = useContext(GlobalConfigContext);
  return (
    <div className="campaign-list-table-wrapper" style={{ width: "100%" }}>
      <table>
        <thead>
          <tr>
            <th style={{ ...columnStyles.status }}>Status</th>
            <th style={{ ...columnStyles.title }}>Bonus Campaign Name</th>
            <th style={{ ...columnStyles.segment }}>Bonus Campaign Short Name</th>
            <th style={{ ...columnStyles.reward }}>Segment</th>
            <th style={{ ...columnStyles.population }}>Population</th>
            <th style={{ ...columnStyles.population }}>Unique Users</th>
            <th style={{ ...columnStyles.population }}>Success Count</th>
            <th style={{ ...columnStyles.population }}>Failure Count</th>
            <th style={{ ...columnStyles.population }}>Create Date</th>
            <th style={{ ...columnStyles.population }}>Job Running Date</th>
            <th style={{ ...columnStyles.actions }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {campaignData.map((campaign, index) => {
            const { displaySegment, totalPopulation } = segmentData[campaign.id] || {
              displaySegment: "-",
              totalPopulation: "-",
            };

            const actionButtons = getCampaignActionButtons({
              campaign,
              handleEditCampaign,
              handleCopyClick,
              handleSummaryClick,
              handleDeleteClick,
              hasAccess,
              isBonusFlowEnabled,
            });

            return (
              <tr key={index}>
                <td style={{ ...columnStyles.status }}>
                  <div className={`status ${campaign?.status?.toLowerCase()}`}>
                    {campaign?.status?.charAt(0).toUpperCase() +
                      campaign?.status?.slice(1).toLowerCase()}
                  </div>
                </td>
                <td
                  className={`${/\s/.test(campaign?.title) ? "" : "no-space-title"}`}
                  style={{ ...columnStyles.title }}
                >
                  {campaign?.title || "-"}
                </td>
                <td style={{ ...columnStyles.segment }}>{campaign?.titleShort}</td>

                <td style={{ ...columnStyles.reward }}>{displaySegment}</td>
                <td style={{ ...columnStyles.population }}>{totalPopulation}</td>
                <td style={{ ...columnStyles.population }}>
                  {campaign?.uniqueSegmentedUsersCount || 0}
                </td>
                <td style={{ ...columnStyles.population }}>
                  {campaign?.summary?.successCount || 0}
                </td>
                <td style={{ ...columnStyles.population }}>
                  {campaign?.summary?.failureCount || 0}
                </td>
                <td style={{ ...columnStyles.population }}>
                  {campaign?.activeStartDate
                    ? getDateWithFormat(
                        campaign.activeStartDate,
                        programTimezone,
                        "DD/MM/YYYY hh:mm a"
                      )
                    : "N/A"}
                </td>
                <td style={{ ...columnStyles.population }}>
                  {campaign?.activeEndDate
                    ? getDateWithFormat(
                        campaign.activeEndDate,
                        programTimezone,
                        "DD/MM/YYYY hh:mm a"
                      )
                    : "N/A"}
                </td>
                <td style={{ ...columnStyles.actions }}>
                  <ButtonGroupDynamic
                    items={actionButtons}
                    spacing="0px"
                    size="small"
                    variant="control"
                  />
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default BonusListView;
